import { render, staticRenderFns } from "./ItemGolTarjeta.vue?vue&type=template&id=df95a200&"
import script from "./ItemGolTarjeta.vue?vue&type=script&lang=js&"
export * from "./ItemGolTarjeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports